:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host,
.group {
  display: grid;
  grid-template-rows: min-content;
}

.action::before {
  content: "";
  inline-size: var(--ch-action-list-group__expandable-button-size);
  block-size: var(--ch-action-list-group__expandable-button-size);
  background-color: currentColor;
  -webkit-mask: no-repeat center/var(--ch-action-list-group__expandable-button-image-size) url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>');
}
.action--collapsed::before {
  transform: rotate(-90deg);
}

.expandable {
  display: grid;
  grid-auto-rows: min-content;
  position: relative;
  padding: 0;
  margin: 0;
}
.expandable--lazy-loaded {
  content-visibility: auto;
  contain-intrinsic-size: auto 100px;
}

.expandable--collapsed {
  display: none;
  overflow: hidden;
}